import { useInfiniteQuery } from '@tanstack/react-query';

import { $apiV2, infinityNextPageParam, IWithPagination } from 'modules/global';

import { courseConst, ICourse, SortsType } from '..';

export const fetchCoursesSitemap = async () => {
  const { data } = await $apiV2.get('/teacher-course/view', {
    params: { size: 32 }
  });

  return data;
};

export const getCourses =
  ({ type, search, size = 24, sortByCreatedAt, sortByPrice, sortByRating, categoryIds }: SortsType) =>
  async ({ pageParam = 1 }) => {
    const { data } = await $apiV2.get('/teacher-course/view', {
      params: {
        page: pageParam,
        type,
        search,
        size,
        sort_by_created_at: sortByCreatedAt,
        sort_by_price: sortByPrice,
        sort_by_rating: sortByRating,
        category_id: categoryIds
      }
    });

    return data;
  };

export const useCourses = ({ type, search, enabled, sortByCreatedAt, sortByRating, categoryIds }: SortsType) => {
  const query = useInfiniteQuery<IWithPagination<ICourse[]>>({
    queryKey: [courseConst.queryKeys.COURSES, search, type, sortByCreatedAt, sortByRating, categoryIds],
    queryFn: getCourses({ search, type, sortByCreatedAt, sortByRating, categoryIds }),
    getNextPageParam: infinityNextPageParam<IWithPagination<ICourse[]>>(24),
    enabled
  });

  const courses = query.data?.pages.flatMap(page => page.data) ?? [];

  return { ...query, courses };
};
